import React from 'react';
import {ToDoListWidget} from './ToDoListWidget';
import {getServerTexts} from '../texts';

export async function renderToDoListWidget(root, props) {
    await getServerTexts();
    return root.render(<ToDoListWidget props={props} />);
}
